import { Button } from '@zoom/react-ui'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'
import { selectImages, selectTotalImages, selectIsSearching } from './reducer'
import SearchResults from './SearchResults'
import SearchForm from './SearchForm'
import { useEffect, useCallback, useRef } from 'react'
import { search } from './actions'
import { capitalizeFirstLetter } from '../util'
import laptopSadFace from './laptop-sad-face.png'
import * as CONSTANTS from './constants'
import VirtualBackgroundMenu from '../vb/VirtualBackgroundMenu'
import './SearchPage.css'

function ZeroSearchResults() {
  return (
    <div className="zero-search-results-container">
      <div className="zero-search-results">{CONSTANTS.NO_SEARCH_RESULTS}</div>
      <img
        className="zero-search-results-image"
        alt="laptop-sad-face"
        src={laptopSadFace}
      />
    </div>
  )
}

function SearchPage() {
  const dispatch = useDispatch()
  const images = useSelector(selectImages)
  const totalSearchPageImages = useSelector(selectTotalImages)
  const isSearching = useSelector(selectIsSearching)
  const location = useLocation()
  const history = useHistory()
  const showZeroSearchResults = totalSearchPageImages === 0 && !isSearching
  const showSearchResults = totalSearchPageImages > 0

  const { state } = location
  const searchTerm = state
    ? state.searchTerm
    : new URLSearchParams(location.search).get('query')

  const onSearch = useCallback(
    (searchTerm) => {
      history.push({
        pathname: '/search',
        search: `?query=${encodeURIComponent(searchTerm)}`,
        state: { searchTerm },
      })
    },
    [history]
  )

  const navigateHome = useCallback(() => history.push('/'), [history])

  const prevSearchTerm = useRef(null)
  useEffect(() => {
    if (searchTerm === prevSearchTerm.current) return
    prevSearchTerm.current = searchTerm
    dispatch(search({ query: searchTerm, page: 1 }))
  }, [dispatch, searchTerm])

  return (
    <div className="search-results-page-container">
      <div className="sticky-top-content">
        <div className="SearchPage__header">
          <Button
            type="tertiary"
            className="search-back-button"
            onClick={navigateHome}
          >
            &lt; Back
          </Button>
          <SearchForm searchTerm={searchTerm} handleSubmit={onSearch} />
          <VirtualBackgroundMenu />
        </div>
        {!!totalSearchPageImages && (
          <div
            data-testid="searchResultsAmount"
            className="search-results-amount"
          >
            <div className="search-results-name">
              {capitalizeFirstLetter(searchTerm)}
            </div>
            <div className="search-results-total">
              {`(${totalSearchPageImages.toLocaleString()} results)`}
            </div>
          </div>
        )}
      </div>
      {showZeroSearchResults && <ZeroSearchResults />}
      {showSearchResults && (
        <SearchResults
          searchTerm={searchTerm}
          images={images}
          isSearching={isSearching}
          totalImages={totalSearchPageImages}
        />
      )}
    </div>
  )
}

export default SearchPage
